var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "page-wrap" }, [
    _c("div", { staticClass: "search" }, [
      _c("div", { staticClass: "title" }, [
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入订单编号", clearable: "" },
              model: {
                value: _vm.formData.order_no,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "order_no", $$v)
                },
                expression: "formData.order_no",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入售后单号", clearable: "" },
              model: {
                value: _vm.formData.as_no,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "as_no", $$v)
                },
                expression: "formData.as_no",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-date-picker", {
              attrs: {
                format: "yyyy-MM-dd",
                "value-format": "yyyy-MM-dd",
                type: "date",
                placeholder: "选择支付起始",
              },
              model: {
                value: _vm.formData.pay_start,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "pay_start", $$v)
                },
                expression: "formData.pay_start",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-date-picker", {
              attrs: {
                type: "date",
                format: "yyyy-MM-dd",
                "value-format": "yyyy-MM-dd",
                placeholder: "选择支付截止",
              },
              model: {
                value: _vm.formData.pay_end,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "pay_end", $$v)
                },
                expression: "formData.pay_end",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item multiple-select-long" },
          [
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  multiple: "",
                  clearable: "",
                  "collapse-tags": "",
                  placeholder: "选择城市仓",
                },
                on: { change: _vm.cityChange },
                model: {
                  value: _vm.formData.logistics_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "logistics_id", $$v)
                  },
                  expression: "formData.logistics_id",
                },
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "el-select-dropdown__item",
                    class: { selected: _vm.serviceSelectedAll },
                    on: { click: _vm.onServiceSelectedAll },
                  },
                  [_c("span", [_vm._v("全选")])]
                ),
                _vm._l(_vm.userList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item multiple-select" },
          [
            _c(
              "el-select",
              {
                attrs: {
                  multiple: "",
                  clearable: "",
                  placeholder: "选择自提点",
                },
                model: {
                  value: _vm.formData.delivery_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "delivery_id", $$v)
                  },
                  expression: "formData.delivery_id",
                },
              },
              _vm._l(_vm.selflist, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item multiple-select" },
          [
            _c(
              "el-select",
              {
                attrs: { clearable: "", placeholder: "请选择集配中心" },
                model: {
                  value: _vm.formData.logistic_business_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "logistic_business_id", $$v)
                  },
                  expression: "formData.logistic_business_id",
                },
              },
              _vm._l(_vm.options, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id + "" },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入电话", clearable: "" },
              model: {
                value: _vm.formData.mobile,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "mobile", $$v)
                },
                expression: "formData.mobile",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入供货单号", clearable: "" },
              model: {
                value: _vm.formData.supplier_order_no,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "supplier_order_no", $$v)
                },
                expression: "formData.supplier_order_no",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入微信支付单号", clearable: "" },
              model: {
                value: _vm.formData.trade_no,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "trade_no", $$v)
                },
                expression: "formData.trade_no",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入退款单号", clearable: "" },
              model: {
                value: _vm.formData.refund_no,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "refund_no", $$v)
                },
                expression: "formData.refund_no",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-date-picker", {
              attrs: {
                type: "date",
                format: "yyyy-MM-dd",
                "value-format": "yyyy-MM-dd",
                placeholder: "选择退款起始",
              },
              model: {
                value: _vm.formData.refund_start,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "refund_start", $$v)
                },
                expression: "formData.refund_start",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-date-picker", {
              attrs: {
                type: "date",
                format: "yyyy-MM-dd",
                "value-format": "yyyy-MM-dd",
                placeholder: "选择退款截止",
              },
              model: {
                value: _vm.formData.refund_end,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "refund_end", $$v)
                },
                expression: "formData.refund_end",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c(
              "el-select",
              {
                attrs: { clearable: "", placeholder: "选择退款状态" },
                model: {
                  value: _vm.formData.refund_status,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "refund_status", $$v)
                  },
                  expression: "formData.refund_status",
                },
              },
              _vm._l(_vm.statusList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.name, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item multiple-select" },
          [
            _c(
              "el-select",
              {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择供应商",
                },
                model: {
                  value: _vm.formData.supplier_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "supplier_id", $$v)
                  },
                  expression: "formData.supplier_id",
                },
              },
              _vm._l(_vm.supplierList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: {
                    label: `${item.title}【${item.mobile}】`,
                    value: item.id,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item multiple-select" },
          [
            _c(
              "el-select",
              {
                attrs: {
                  clearable: "",
                  filterable: "",
                  placeholder: "请选择业务",
                },
                model: {
                  value: _vm.formData.buyer_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "buyer_id", $$v)
                  },
                  expression: "formData.buyer_id",
                },
              },
              _vm._l(_vm.buyerList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: {
                    label: `${item.fullname}【${item.mobile}】`,
                    value: item.id,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c("el-button", {
              staticClass: "bjsearch",
              attrs: { type: "primary", icon: "el-icon-refresh" },
              on: { click: _vm.onHandleRefresh },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.onHandleSearch },
              },
              [_vm._v("查询")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-item" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "warning", icon: "el-icon-upload2" },
                on: { click: _vm.onHandleExport },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "table-wrap" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              height: "100%",
              border: "",
              data: _vm.dataList,
              "header-cell-style": { color: "#333333", background: "#EFF6FF" },
              "tooltip-effect": "dark",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: "集配中心",
                prop: "logistic_business_name",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "订单编号", prop: "order_no", align: "center" },
            }),
            _c("el-table-column", {
              attrs: { label: "售后单号", prop: "as_no", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "微信交易单号",
                prop: "trade_no",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "供货单号",
                prop: "supplier_order_no",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单创建时间",
                prop: "order_time",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$empty.time(scope.row.order_time)) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "客户名称", prop: "user_name", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "客户电话",
                prop: "user_mobile",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "支付时间", prop: "pay_at", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "退款状态",
                prop: "order_refund_state",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "订单金额",
                prop: "order_amount",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "城市仓",
                prop: "store_logistic_name",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "自提点",
                prop: "store_delivery_name",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "退款金额",
                prop: "aftersale_amount",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "退款单号", prop: "refund_no", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "退款时间",
                prop: "refund_time",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "供应商",
                prop: "supplier_name",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "业务", prop: "buyer_name", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: "缺货商品",
                prop: "product_name",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "缺货件数",
                prop: "product_num",
                align: "center",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "fy" },
      [
        _c("el-pagination", {
          attrs: {
            type: "primary",
            background: "",
            "current-page": _vm.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _vm.formData.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.onHandleSizeChange,
            "current-change": _vm.onHandleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }